import { CrudList } from '../shared/CrudPage';
import { couponService } from '@kss/api';
import type { Coupon, CouponCreate, CouponFilter } from '@kss/api';

export default function AllCoupons() {
  return (
    <CrudList<Coupon, CouponCreate, CouponFilter>
      title="Coupons"
      newLabel="New coupon"
      service={couponService}
      idKey="couponId"
      labelKey="name"
      basePath="/panel/coupons"
      columns={[
        { accessor: 'code', title: 'Code', width: 140, filterable: true },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        { accessor: 'couponType' as never, title: 'Type', width: 130 },
        { accessor: 'discountValue' as never, title: 'Discount', width: 120 },
        { accessor: 'usageLimit' as never, title: 'Usage', width: 100 },
      ]}
    />
  );
}
